/* eslint-disable no-restricted-globals */
import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { Col, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import FileDownload from 'react-file-download';
import irelandApi from '../../../../irelandApi';
import PageTitle from '../../../common/page-title';
import RequiredDatePicker from '../../../common/form/elements/required-datepicker';
import RequiredInput from '../../../common/form/elements/required-input';
import RequiredMultiSelect from '../../../common/form/elements/required-multi-select';
import RequiredRadioGroup from '../../../common/form/elements/required-radio-group';
import BsRadio from '../../../common/form/elements/bs-radio';
import TextInput from '../../../common/form/elements/text-input';
import ArrowButton from '../../../common/button-arrow';
import BackLink from '../../../common/back-link/index';
import { getIncentive, saveIncentive, updateIncentive } from '../../../../actions/incentives';
import FileUpload from '../../../common/form/elements/file-upload';
import ImageUpload from '../../../common/form/elements/image-upload';
import { validators } from '../../../../utils/validators';
import { editOverride } from '../../../../utils/objectivesEditOverride';
import t from '../../../../data/translations';
import EligibilityDropdowns from '../../objectives/eligibility-dropdowns';
import Select from '../../../common/form/elements/select';
import ToastMessage from '../../../common/toast-message';

import './styles.css';
import { checkPermission } from '../../../common/guards/can';
import GameLevelForm from '../game-levels/game-level-form';

class AddIncentives extends Component {
  handleAddMore = (event) => {
    this.setState({ pack: event.target.value });
  };

  handleBonusPointsChange(value) {
    const { dispatch } = this.props;

    if (value === 'false') {
      ['bonus_points_to', 'bonus_points_from', 'bonus_points_to_target', 'bonus_points_to_target_2',
        'bonus_points_after_target', 'bonus_link', 'maximum_bonus_submissions'].forEach((field) => {
        dispatch(actions.setValidity(`deep.incentives.${field}`, true));
        dispatch(actions.change(`deep.incentives.${field}`, null));
      });
    }
  }

  bonusPointsDisabled = () => {
    if (!this.edit) {
      return false;
    }

    const { attributes } = this.props.incentive;

    if (attributes) {
      return (
        this.props.bonusPoints === 'true' &&
        attributes['bonus-points-to'] !== null &&
        attributes['bonus-points-from'] !== null &&
        attributes['bonus-points-to-target'] !== null &&
        this.props.kind === 'base_target' ? attributes['bonus-points-to-target-2'] !== null : true &&
        attributes['bonus-points-after-target'] !== null &&
        attributes['maximum-bonus-submissions'] !== null
      );
    }

    return false;
  }

  createProductList = products => products.map(curr => ({
    label: `${curr.sku_name} ${curr.sku_code}`,
    value: curr.id
  }));

  createOptionsList = object => object.map(curr => ({
    label: `${curr.name}`,
    value: curr.id
  }));

  renderIncentiveTypes = () => {
    const { incentiveTypes } = this.props;

    return Object.keys(incentiveTypes)
      .map(curr => (
        <Col key={curr} md={4} sm={6} xs={12}>
          <Control.radio
            component={BsRadio}
            disabled={editOverride(this)}
            model={'deep.incentives.kind'}
            onChange={this.handleAddMore}
            value={curr}
          >
            {incentiveTypes[curr]}
          </Control.radio>
        </Col>
      ));
  };

  onSubmit = (data) => {
    const {dispatch} = this.props;

    if (this.edit) {
      dispatch(actions.submitFields('deep.incentives', updateIncentive(this.id, data, dispatch)));
    } else {
      dispatch(actions.submitFields('deep.incentives', saveIncentive(data, dispatch)));
    }
  };

  downloadCSV = () => {
    irelandApi.get(`/api/admin/incentives/${this.props.incentive.id}/download`, {headers: {Accept: 'text/csv'}})
      .then((response) => {
        FileDownload(response.data, 'unprocessed_ppc_orders.csv');
      })
      .catch(() => {
        toast.error(<ToastMessage iconStyle="error" message="Cannot download export data"/>);
      });
  };

  constructor(props) {
    super(props);

    this.state = {
      pack: t('packsSold'),
      disabled: false,
      incentiveTypes: '',
      productList: '',
      groupList: ''
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.id = +this.props.match.params.id;
    this.edit = !isNaN(this.id);

    dispatch(getIncentive(this.id));

    if (!this.edit) {
      dispatch(actions.reset('deep.incentives'));
    }
  }

  componentDidUpdate(prevProps) {
    const { formData: { target, name }, dispatch } = prevProps;

    if (target !== this.props.formData.target) {
      dispatch(actions.resetValidity('deep.incentives'));

      if (name === '') {
        dispatch(actions.setValidity('deep.incentives.name', false));
      }
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.incentives'));
  }

  zeroTarget = () => {
    const { formData: { target } } = this.props;

    return parseInt(target) === 0;
  };

  packsSoldFields = () => {
    const changePointParametersPermission = checkPermission('change-point-parameters', 'Incentive');
    const isDisabled = editOverride(this) && !changePointParametersPermission;

    return (
      <div>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Target*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={isDisabled}
              model=".target"
              placeholder="Target"
              controlId="target"
              zeroAllowed
              type="number"
            />
          </Col>
        </Row>
        {!this.zeroTarget() && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Points To Target*</h4>
            </Col>
            <Col md={9}>
              <RequiredInput
                disabled={isDisabled}
                model=".points_to_target"
                placeholder="Points To Target"
                controlId="pointToTarget"
                zeroAllowed
                type="number"
              />
            </Col>
          </Row>
        )}
        {!this.zeroTarget() && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Points After Target*</h4>
            </Col>
            <Col md={9}>
              <RequiredInput
                disabled={isDisabled}
                model=".points_after_target"
                placeholder="Points After Target"
                controlId="pointsAfterTarget"
                zeroAllowed
                type="number"
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }

  percentageIncreaseFields = () => (
    <div>
      <Row>
        <Col md={3}>
          <h4>% Calculation From Date*</h4>
        </Col>
        <Col md={9}>
          <RequiredDatePicker
            model="deep.incentives.percentage_calculate_from"
            disabled={editOverride(this)}
            controlId="percentage_calculate_from"
            value={this.props.percentageCalculateFrom}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <h4>% Calculation to Date*</h4>
        </Col>
        <Col md={9}>
          <RequiredDatePicker
            model="deep.incentives.percentage_calculate_to"
            disabled={editOverride(this)}
            controlId="percentage_calculate_to"
            value={this.props.percentageCalculateTo}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Target (%)*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".target"
            placeholder="Target (%)"
            controlId="target"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Default target*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".default_target"
            placeholder="Default target"
            controlId="defaultTarget"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Points To Target*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".points_to_target"
            placeholder="Points To Target"
            controlId="pointToTarget"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Points After Target*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".points_after_target"
            placeholder="Points After Target"
            controlId="pointsAfterTarget"
          />
        </Col>
      </Row>
    </div>
  );

  baseTargetFields = () => (
    <div>
      {!this.edit && (
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Upload Target 1*</h4>
        </Col>
        <Col md={9}>
          <FileUpload required/>
        </Col>
      </Row>
        )}
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Target 2 (%)*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".target"
            placeholder="Target 2 (%)"
            controlId="target"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Points To Target 1*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".points_to_target"
            placeholder="Points To Target 1"
            controlId="pointToTarget"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Points To Target 2*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".points_to_target_2"
            placeholder="Points To Target 2"
            controlId="pointToTarget"
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} className="add-incentives">
          <h4>Points After Target*</h4>
        </Col>
        <Col md={9}>
          <RequiredInput
            disabled={editOverride(this)}
            model=".points_after_target"
            placeholder="Points After Target"
            controlId="pointsAfterTarget"
          />
        </Col>
      </Row>
    </div>
  );

  bonusPointsFields() {
    let bonusPointsFrom = '';
    let bonusPointsTo = '';
    const { attributes } = this.props.incentive;

    if (attributes) {
      bonusPointsFrom = attributes['bonus-points-from'];
      bonusPointsTo = attributes['bonus-points-to'];
    }

    return (
      <div>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Bonus Points To Target*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.bonusPointsDisabled()}
              model=".bonus_points_to_target"
              placeholder="Bonus Points To Target"
              controlId="bonusToTarget"
            />
          </Col>
        </Row>
        { this.props.kind === 'base_target' && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Bonus Points To Target 2*</h4>
            </Col>
            <Col md={9}>
              <RequiredInput
                disabled={this.bonusPointsDisabled()}
                model=".bonus_points_to_target_2"
                placeholder="Bonus Points To Target 2"
                controlId="bonusToTarget2"
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Bonus Points After Target*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.bonusPointsDisabled()}
              model=".bonus_points_after_target"
              placeholder="Bonus Points After Target"
              controlId="bonusPointAfterTarget"
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Maximum Bonus Submissions*</h4>
          </Col>
          <Col md={9}>
            <RequiredInput
              disabled={this.bonusPointsDisabled()}
              model=".maximum_bonus_submissions"
              placeholder="Maximum Bonus Submissions"
              controlId="maxBonusSubmissions"
            />
          </Col>
        </Row>
        {!this.zeroTarget() && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Bonus Points From*</h4>
            </Col>
            <Col md={9}>
              <RequiredDatePicker
                disabled={this.bonusPointsDisabled()}
                model="deep.incentives.bonus_points_from"
                controlId="bonus_points_from"
                placeholder="Must be after start date and before end date"
                value={bonusPointsFrom}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3} className="add-incentives">
            <h4>Bonus Points To*</h4>
          </Col>
          <Col md={9}>
            <RequiredDatePicker
              model="deep.incentives.bonus_points_to"
              controlId="bonus_points_to"
              placeholder="Must be after start date and before end date"
              value={bonusPointsTo}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3} className="add-incentives">
            <h4>More Info Link</h4>
          </Col>
          <Col md={9}>
            <TextInput
              model=".bonus_link"
              placeholder="More info link"
              controlId="bonus_link"
              inputType="url"
              validators={{isUrl: validators.isUrl(this.updateErrors, 'bonus_link')}}
            />
          </Col>
        </Row>
      </div>
    );
  }

  commonFields = () => {
    const bonusPointsOptions = [
      {
        label: 'Yes',
        value: 'true'
      },
      {
        label: 'No',
        value: 'false'
      }
    ];

    return (
      <div>
        {!this.zeroTarget() && (
          <Row>
            <Col md={3} className="add-incentives">
              <h4>Max Points Per Outlet</h4>
            </Col>
            <Col md={9}>
              <FormGroup controlId="maxPointsPerOutlet">
                <Control.text
                  model=".maximum_points"
                  disabled={editOverride(this)}
                  placeholder="Max Points Per Outlet"
                  component={FormControl}
                  type="number"
                  min={1}
                />
                <Errors
                  show={{touched: true, focus: false}}
                  className="errors"
                  model=".maximum_points"
                />
              </FormGroup>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={3}>
            <h4>Display From Date*</h4>
          </Col>
          <Col md={9}>
            <RequiredDatePicker
              model="deep.incentives.display_from"
              controlId="display_from'"
              value={this.props.displayFrom}
            />
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <h4>Display To Date*</h4>
          </Col>
          <Col md={9}>
            <RequiredDatePicker
              model="deep.incentives.display_to"
              controlId="display_to'"
              value={this.props.displayTo}
            />
          </Col>
        </Row>
        {!this.zeroTarget() && (
          <Row>
            <Col md={3}>
              <FormLabel>Add bonus points?*</FormLabel>
            </Col>
            <Col md={9}>
              <RequiredRadioGroup
                disabled={this.bonusPointsDisabled()}
                model="deep.incentives.bonus_points_enabled"
                controlId="bonus_points_enabled"
                radios={bonusPointsOptions}
                inline
                onChange={event => this.handleBonusPointsChange(event.target.value) }
              />
            </Col>
          </Row>
         )}
      </div>
    );
  }

  render() {
    const {
      isLoading, gameQualificationChance, formData, products, types
    } = this.props;

    const multiselect = (
      <div>
        <RequiredMultiSelect
          data={this.createProductList(products)}
          value={this.props.savedProducts}
          disabled={editOverride(this)}
          controlId="products"
          model='deep.incentives.product_ids'
        />
      </div>
    );

    return (
      <div className="container-fluid incentive-form">
        <Row>
          <Col md={12}>
            <BackLink href="/admin/incentives"/>
            <PageTitle>{`${this.edit ? 'View' : 'Add'} incentive ${(!Number.isNaN(this.id) ? `ID: ${this.id}` : '')}`}</PageTitle>
            { this.edit && (
              <ArrowButton
                submit={false}
                arrow={false}
                className="float-end"
                permissions={{
                            action: 'generate-points-export',
                            subjectClass: 'Incentive'
                          }}
                onClick={this.downloadCSV}
              >
                Generate points import
              </ArrowButton>
            )}
          </Col>
        </Row>
        {isLoading ? <p>Loading...</p> : (
          <Col md={12}>
            <Row>
              <Form model="deep.incentives" onSubmit={this.onSubmit}>
                <Errors className="errors" model="deep.incentives"/>
                <Row>
                  <Col md={3} className="add-incentives">
                    <h4>Incentive Name*</h4>
                  </Col>
                  <Col md={9}>
                    <RequiredInput
                      model=".name"
                      placeholder="Incentive Name"
                      controlId="loadPoints"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3} className="add-incentives">
                    <h4>Incentive Description</h4>
                  </Col>
                  <Col md={9}>
                    <Control.textarea
                      className="form-control"
                      model=".description"
                      rows="5"
                      placeholder="Incentive description"
                    />
                  </Col>
                </Row>
                {!this.zeroTarget() && (
                  <Row>
                    <Col md={3}>
                      <h4>Incentive Category*</h4>
                    </Col>
                    <Col md={9}>
                      <Select
                        model="deep.incentives.incentive_type"
                        values={types}
                        selectedValue={types[0] ? types[0].value : ''}
                        required
                        hasEmptyValue={false}
                      />
                    </Col>
                  </Row>
                )}
                <EligibilityDropdowns
                  mc_outlets={this.props.mcOutlets}
                  abm_codes={this.props.abm_codes}
                  wse_bands={this.props.wse_bands}
                  groups={this.props.groups}
                  postcodes={this.props.postcodes}
                  sub_zones={this.props.sub_zones}
                  zones={this.props.zones}
                  model='incentives'
                />
                <Row>
                  <Col md={3}>
                    <h4>Incentive Start Date*</h4>
                  </Col>
                  <Col md={9}>
                    <RequiredDatePicker
                      disabled={editOverride(this)}
                      model="deep.incentives.start_date"
                      controlId="start_date"
                      value={this.props.startDate}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={3}>
                    <h4>Incentive End Date*</h4>
                  </Col>
                  <Col md={9}>
                    <RequiredDatePicker
                      model="deep.incentives.end_date"
                      controlId="end_date"
                      value={this.props.endDate}
                    />
                  </Col>
                </Row>
                {!this.zeroTarget && (
                  <Row>
                    <Col md={3}>
                      <h4>Submission grace period (days)</h4>
                    </Col>
                    <Col md={9}>
                      <FormGroup controlId="submission_grace_period">
                        <Control
                          model="deep.incentives.submission_grace_period"
                          type="number"
                          value={this.props.submissionGracePeriod}
                          min="0"
                          component={FormControl}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={3}>
                    <h4>Eligible SKUs*</h4>
                  </Col>
                  <Col md={9}>
                    {multiselect}
                  </Col>
                </Row>
                {!this.zeroTarget() && (
                  <Row>
                    <Col md={3}>
                      <h4>Incentive Type*</h4>
                    </Col>
                    <Col md={9}>
                      <Row>
                        { this.renderIncentiveTypes() }
                      </Row>
                    </Col>
                  </Row>
                )}
                {this.zeroTarget() && (
                  <Row>
                    <Col md={3}>
                      <h4>Qualification chance</h4>
                    </Col>
                    <Col md={9}>
                      <FormGroup controlId="game_qualification_chance">
                        <Control
                          model="deep.incentives.game_qualification_chance"
                          type="number"
                          value={gameQualificationChance}
                          min={0}
                          max={100}
                          step={1}
                          component={FormControl}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}

                { this.props.kind === 'base_target' && this.baseTargetFields() }
                { this.props.kind === 'packs_sold' && this.packsSoldFields() }
                { this.props.kind === 'percentage_increase' && this.percentageIncreaseFields() }
                { this.commonFields()}
                { this.props.bonusPoints === 'true' && this.bonusPointsFields() }

                <Col md={12}>
                  <Row>
                    <Col md={12}>
                      <FormLabel>{this.zeroTarget() ? 'Image' : 'Image*'}</FormLabel>
                      <ImageUpload
                        source={(formData.links && formData.links.image) ? formData.links.image : ''}
                        model='deep.incentives.image'
                        sizeLimit={1024 * 1024}
                        type={['image/png', 'image/jpg', 'image/jpeg']}
                      />
                    </Col>
                  </Row>
                  {this.zeroTarget() && (
                    <Row>
                      <Col>
                        <GameLevelForm />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <ArrowButton className="float-right" color="red" disabled={!this.props.formValid}>Save</ArrowButton>
                  </Row>
                </Col>
              </Form>
            </Row>
          </Col>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formValid: state.deep.forms.incentives.$form.valid,
  formData: state.deep.incentives,
  incentive: state.incentives.incentive,
  displayFrom: state.deep.incentives.display_from || '',
  mcOutlets: state.deep.incentives.mc_outlets || null,
  displayTo: state.deep.incentives.display_to || '',
  percentageCalculateFrom: state.deep.incentives.percentage_calculate_from || '',
  percentageCalculateTo: state.deep.incentives.percentage_calculate_to || '',
  startDate: state.deep.incentives.start_date || '',
  endDate: state.deep.incentives.end_date || '',
  currentDateBeforeStartDate: state.deep.incentives.current_date_before_start_date || false,
  submissionGracePeriod: state.deep.incentives.submission_grace_period || '',
  gameQualificationChance: state.deep.incentives.game_qualification_chance || '',
  kind: state.deep.incentives.kind || '',
  savedProducts: state.deep.incentives.product_ids || [],
  savedGroups: state.deep.incentives.group_ids || [],
  meta: state.incentives.meta,
  incentiveTypes: state.incentives.meta['incentive-types'] || {},
  types: state.incentives.meta.types || {},
  products: state.incentives.meta.products || [],
  groups: state.deep.incentives.groups || [],
  abm_codes: state.deep.incentives.abm_codes || [],
  wse_bands: state.deep.incentives.wse_bands || [],
  postcodes: state.deep.incentives.postcodes || [],
  sub_zones: state.deep.incentives.sub_zones || [],
  zones: state.deep.incentives.zones || [],
  bonusPoints: state.deep.incentives.bonus_points_enabled || 'false',
  isLoading: state.incentives.fetching && !state.incentives.fetched
});

export default connect(mapStateToProps)(AddIncentives);
